import "../monacoSetup"; // self-host Monaco (no CDN) before the loader runs
import Editor, { type OnMount } from "@monaco-editor/react";

export type MonacoEditor = Parameters<OnMount>[0];
export type MonacoNs = Parameters<OnMount>[1];

type Props = {
  value: string;
  onChange: (value: string) => void;
  fontSize: number;
  onRun: () => void;
  onReady?: (editor: MonacoEditor, monaco: MonacoNs) => void;
};

// Monaco configured to match MicroPython/Thonny conventions (spec §6.2): spaces
// not tabs, tab size 4, no auto-formatting. Scripts stay byte-clean so they
// round-trip with Thonny and the real robot (R8).
export default function CodeEditor({ value, onChange, fontSize, onRun, onReady }: Props) {
  const handleMount: OnMount = (editor, monaco) => {
    // Ctrl+Enter = Run (spec §6.2).
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter, () => onRun());
    onReady?.(editor, monaco);
  };

  return (
    <Editor
      height="100%"
      defaultLanguage="python"
      theme="vs-dark"
      value={value}
      onChange={(v) => onChange(v ?? "")}
      onMount={handleMount}
      options={{
        fontSize,
        insertSpaces: true,
        tabSize: 4,
        detectIndentation: false,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        automaticLayout: true,
        renderWhitespace: "selection",
        formatOnPaste: false,
        formatOnType: false,
      }}
    />
  );
}
